
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { forceAppRefresh } from '@/utils/app-version';
import { toast } from 'sonner';
import { isStandalone } from '@/utils/device';

interface PWARefreshButtonProps {
  className?: string;
}

export const PWARefreshButton = ({ className = '' }: PWARefreshButtonProps) => {
  // Only show in standalone PWA mode
  const isPWA = isStandalone();
  
  if (!isPWA) return null;
  
  const handleRefresh = () => {
    toast.info("Refreshing application...", {
      description: "Clearing cache and reloading"
    });
    // Fire immediately — the prior 800ms delay made the first tap feel
    // like a no-op on iOS PWA, prompting users to tap a second time.
    void forceAppRefresh();
  };
  
  return (
    <Button 
      variant="outline" 
      size="icon"
      className={`touch-manipulation ${className}`}
      onClick={handleRefresh}
      title="Force refresh PWA app"
    >
      <RefreshCw className="h-4 w-4" />
    </Button>
  );
};
